export default "https://assets.pclncdn.com/web/next-landing/49d3d019e1/_next/static/images/dallas-1ce02af7045ec1a9486cfbd00bc374cd.webp";